<template>
  <header class="header">
    <img class="header-banner" src="@/assets/img/banner.jpg">

    
  </header>
</template>

<style scoped>
  .header {
    background-color: #558cbe;
    padding: 0px;
    margin-left: auto;
    margin-right: auto;

    max-width: var(--page-size);
    /*min-width: 500px;*/

    border-radius: 25px;
  }

  .header-banner {
    width: 100%;
    height: 220px;
    margin: 0;
    vertical-align: bottom;

    border-radius: 25px 25px 0 0;
  }
</style>

<script lang="ts">
  import { Component, Vue } from 'vue-property-decorator';
  import NavHeader from '@/components/NavHeader.component.vue'; // @ is an alias to /src

  /**
   * @desc image d'en tête du site
   */
  @Component({
    components: {
      PageHeader,
      NavHeader,
    },
  })
  export default class PageHeader extends Vue {}

</script>
